module.exports = __webpack_public_path__ + "img/JamesWooldridge.b9b56d16.png";